import React from 'react';
import './TaxHero.css';
import tax1 from '../../assets/images/tax1.webp';
import tax2 from '../../assets/images/tax2.webp';
import tax3 from '../../assets/images/tax3.webp';
import tax4 from '../../assets/images/tax4.webp';

const TaxHero = () => {
    return (
        <section className="tax-hero">
            <div className="tax-hero-container">
                <div className="tax-hero-content">
                    <h1 className="tax-hero-title">
                        <span className="tax-hero-title-line tax-hero-title-lead">Stress-Free Tax Services for</span>{' '}
                        <span className="tax-hero-title-highlight">Individuals & Sole Traders</span>{' '}
                        <span className="tax-hero-title-line tax-hero-title-tail">in NSW</span>
                    </h1>
                    <p className="tax-hero-description">
                        PFGS provides tailored tax return solutions designed for individuals, freelancers, and
                        sole traders. We simplify the process, maximize your entitlements, and ensure full
                        compliance — so you can relax, knowing your finances are in expert hands.
                    </p>
                    <div className="tax-hero-buttons">
                        <a className="tax-hero-btn tax-hero-btn-primary" href='/contact'>
                            Request a Quote
                        </a>
                    </div>
                </div>

                {/* Tax Images */}
                <div className="tax-images">
                    <img src={tax1} alt="Tax Service 1" className="tax-image tax-image-1" />
                    <img src={tax2} alt="Tax Service 2" className="tax-image tax-image-2" />
                    <img src={tax3} alt="Tax Service 3" className="tax-image tax-image-3" />
                    <img src={tax4} alt="Tax Service 4" className="tax-image tax-image-4" />
                </div>
            </div>
        </section>
    );
};

export default TaxHero;
